import { getClass } from "../../Helper"

// for colleges only

export const getCanDelivers = (inst, keysOnly) => {
  let class_list = getClass(true);
  let canDeliverObject = {
    ge: [],
    exam: [],
    academic: [],
    vet: [],
    bsb: [],
    chc: [],
    fns: [],
    fsk: [],
    shb: [],
    ict: [],
    sit: [],
    cua: [],
    other: []
  }

  const getValues = (key, whole_name = key) => {
    if (keysOnly) {
      return key;
    }
    else {
      return { key, whole_name }
    }
  }

  for (let category in inst.can_deliver) {
    if (category !== "_id") {
      if(inst.can_deliver[category].length > 0 && Array.isArray(inst.can_deliver[category])) {
        inst.can_deliver[category].forEach(entry => {
          let _class = class_list.find(cl => cl.key === entry);
          if(_class){
            let class_name = _class.whole_name
            let item = getValues(entry, class_name)
            canDeliverObject[category].push(item)
          }
        })
      }
    }
  }

  return canDeliverObject
}
